var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstAidBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.1,9.4h-5.2c0,0-0.1,0-0.1,0c-1.4,0.1-2.6,1.3-2.5,2.7v0.8h10.4v-0.8c0,0,0-0.1,0-0.1 C27.7,10.5,26.5,9.3,25.1,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.1,7.6h-5.2c-2.4,0-4.4,2-4.4,4.4v0.8h-5.2c-1.9,0-3.5,1.6-3.5,3.5v17.5c0,1.9,1.6,3.5,3.5,3.5h24.4 c1.9,0,3.5-1.6,3.5-3.5V16.4c0-1.9-1.6-3.5-3.5-3.5h-5.2v-0.8C29.5,9.6,27.5,7.6,25.1,7.6z M34.7,15.4c0.5,0,0.9,0.4,0.9,0.9v17.4 c0,0.5-0.4,0.9-0.9,0.9H10.3c-0.5,0-0.9-0.4-0.9-0.9V16.4c0-0.5,0.4-0.9,0.9-0.9H34.7z M27.7,11.9c0,0,0,0.1,0,0.1v0.8H17.3v-0.8 c-0.1-1.4,1.1-2.6,2.5-2.7c0,0,0.1,0,0.1,0h5.2C26.5,9.3,27.7,10.5,27.7,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.4,16.4v17.4c0,0.5,0.4,0.9,0.9,0.9h24.4c0.5,0,0.9-0.4,0.9-0.9V16.4c0-0.5-0.4-0.9-0.9-0.9H10.3 C9.8,15.4,9.4,15.9,9.4,16.4z M26.9,23.8v2.7h-3.1v3h-2.6v-3h-3.1v-2.7h3.1v-3h2.6v3H26.9z M33.9,32.9H11.2v-1.7h22.7V32.9z  M11.2,17.3h22.7V19H11.2V17.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2724A",
    points: "21.2,20.8 21.2,23.8 18.1,23.8 18.1,26.4 21.2,26.4 21.2,29.4 23.8,29.4 23.8,26.4 26.9,26.4  26.9,23.8 23.8,23.8 23.8,20.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 17.3,
    fill: "#4AB8DC",
    width: 22.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 31.1,
    fill: "#4AB8DC",
    width: 22.7,
    height: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidBox);
export default __webpack_public_path__ + "static/media/first_aid_box.c7c7d5588b3044b95d87f791e90daf71.svg";
export { ForwardRef as ReactComponent };